// extracted by mini-css-extract-plugin
export default {"container":"DocumentTemplateRulesPage_container__7ANiJ","field":"DocumentTemplateRulesPage_field__EUwUv"};